import { Switch } from 'beam/dist/Switch'
import { FormGroup, FormControlLabel } from 'beam/dist/Form'
import fieldPropTypes from './FieldPropTypes'

const FormSwitchField = props => {
  const { label, field, onChange, isDetached, switchProps, classes } = props
  return (
    <FormGroup classes={classes}>
      <FormControlLabel
        label={label}
        control={
          <Switch
            {...field}
            value={field.value}
            aria-checked={field.value}
            checked={field.value}
            onChange={e => {
              !isDetached && field.onChange(e)
              onChange && onChange(e)
            }}
            {...switchProps}
          />
        }
      />
    </FormGroup>
  )
}

FormSwitchField.propTypes = fieldPropTypes

export default FormSwitchField
